import { useAppSelector } from '../useAppSelector';
import { RootState } from 'v2/resources/types/store';

const useGetData = (name: string) => {
  const data = useAppSelector((state: RootState) => state.dataChat);

  const returnData = JSON.stringify(data[name as keyof typeof data]);

  return { data: returnData };
};

export default useGetData;
